import * as React from "react"

import { cn } from "@/lib/utils"

function getResponsivePaddingOverrides(className) {
  if (!className) return []

  const overrides = []
  const spacing = String.raw`\d+(?:\.\d+)?|px|auto`

  if (className.includes("p-0") && !className.includes("sm:p-0")) {
    overrides.push("sm:p-0")
  }

  if (className.includes("px-0") && !className.includes("sm:px-0")) {
    overrides.push("sm:px-0")
  }

  const pyMatch = className.match(new RegExp(String.raw`\bpy-(?!0\b)(${spacing})\b`))
  if (pyMatch && !className.includes("sm:py-")) {
    overrides.push(`sm:${pyMatch[0]}`)
  }

  const ptMatch = className.match(new RegExp(String.raw`\bpt-(?!0\b)(${spacing})\b`))
  if (ptMatch && !className.includes("sm:pt-")) {
    overrides.push(`sm:${ptMatch[0]}`)
  }

  const pbMatch = className.match(new RegExp(String.raw`\bpb-(?!0\b)(${spacing})\b`))
  if (pbMatch && !className.includes("sm:pb-")) {
    overrides.push(`sm:${pbMatch[0]}`)
  }

  const pMatch = className.match(new RegExp(String.raw`\bp-(?!0\b)(${spacing})\b`))
  if (pMatch && !className.includes("sm:p-")) {
    overrides.push(`sm:${pMatch[0]}`)
  }

  return overrides
}

const Card = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("rounded-lg border border-border bg-card text-card-foreground shadow-sm", className)}
    {...props} />
))
Card.displayName = "Card"

const CardHeader = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      "flex flex-col space-y-1.5 px-4 py-2 sm:px-6 sm:py-2",
      className,
      ...getResponsivePaddingOverrides(className)
    )}
    {...props} />
))
CardHeader.displayName = "CardHeader"

const CardTitle = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("text-2xl font-semibold leading-none tracking-tight", className)}
    {...props} />
))
CardTitle.displayName = "CardTitle"

const CardDescription = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("text-sm text-muted-foreground", className)}
    {...props} />
))
CardDescription.displayName = "CardDescription"

const CardContent = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      "p-4 pt-0 sm:p-6 sm:pt-0",
      className,
      ...getResponsivePaddingOverrides(className)
    )}
    {...props}
  />
))
CardContent.displayName = "CardContent"

const CardFooter = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("flex items-center p-4 pt-0 sm:p-6 sm:pt-0", className)}
    {...props} />
))
CardFooter.displayName = "CardFooter"

export { Card, CardHeader, CardFooter, CardTitle, CardDescription, CardContent }
